module.exports = __webpack_public_path__ + "static/media/abacus.140eab01.svg";